import React from 'react';
import {withStyles} from '@mui/styles'

export const RawHtmlFromDbContent = withStyles({
	root: {
		whiteSpace: 'pre-wrap',
	},
})(({content, classes, children}) => <span className={classes.root} dangerouslySetInnerHTML={{__html: (children || content || '') + ''}}/>);